import React from "react";

export function Ebox() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 17.9999C24 18.526 23.852 19.0138 23.6149 19.4429L16.0371 10.9645L23.5328 4.40648C23.8244 4.86921 24 5.41276 24 6.00013V17.9999ZM12 12.5039L22.4299 3.378C22.0019 3.14369 21.52 3 21.0001 3H2.99998C2.47943 3 1.99732 3.14369 1.57104 3.378L12 12.5039ZM14.9078 11.9518L12.4936 14.0656C12.3524 14.1886 12.1765 14.25 12 14.25C11.8234 14.25 11.6476 14.1886 11.5064 14.0656L9.0916 11.9517L1.41796 20.5385C1.87791 20.8271 2.41696 21 2.99993 21H21.0001C21.5829 21 22.1222 20.8271 22.582 20.5385L14.9078 11.9518ZM0.467327 4.40643C0.175792 4.86916 0 5.41271 0 6.00013V18C0 18.5261 0.147301 19.0139 0.385267 19.443L7.96216 10.9631L0.467327 4.40643Z"
        fill="#29394D"
      />
    </svg>
  );
}
